<template>
  <v-layout elevation-7>
    <v-flex>
      <v-card v-if="model != null">
        <v-parallax src="/static/images/koreanaircargo-card.jpg" height="100">
          <v-layout align-center column justify-center>
            <h1 class="display-1 mb-1 s-card-title font-effect-3d-float">대한항공 카고</h1>
            <h4
              style="width:100%; padding-left:10px; padding-right:10px;"
              class="subheading s-card-subtitle text-xs-center"
            >{{ model.baseInfo.status}}</h4>
          </v-layout>
        </v-parallax>

        <v-container id="grid" fluid grid-list-sm tag="section">
          <v-layout wrap>
            <v-flex lg6 md6 sm6 xs6 pl-2 pr-2>
              <v-flex class="gray--text">편명</v-flex>
              <v-btn
                small
                style="margin:0px; padding:0px;"
                slot="activator"
                color="red lighten-2"
                dark
                :to="{name: 'flightModal', params: {sanm: model.baseInfo.flightNo}}"
              >
                <v-flex class="body-2 text-xs-center">
                  <span v-html="model.baseInfo.flightNo"></span>
                </v-flex>
              </v-btn>
            </v-flex>
            <v-flex lg6 md6 sm6 xs6 pl-2 pr-2>
              <LabelText title="기종" :text="model.baseInfo.flightModel"></LabelText>
              <v-divider></v-divider>
            </v-flex>
            <v-flex lg6 md6 sm6 xs6 pl-2 pr-2>
              <label-text title="출발지" :text="model.baseInfo.origin"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <v-flex lg6 md6 sm6 xs6 pl-2 pr-2>
              <LabelText title="출발예정시간" :text="model.baseInfo.departureDate + '/' + model.baseInfo.departureTime"></LabelText>
              <v-divider></v-divider>
            </v-flex>
            <v-flex lg6 md6 sm6 xs6 pl-2 pr-2>
              <label-text title="도착지" :text="model.baseInfo.destination"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <v-flex lg6 md6 sm6 xs6 pl-2 pr-2>
              <label-text title="도착예정시간" :text="model.baseInfo.arrivalTime"></label-text>
              <v-divider></v-divider>
            </v-flex>
          </v-layout>
        </v-container>
        <v-divider></v-divider>

        <v-container v-if="!hasResult" fill-height fluid>
          <v-layout column class="text-xs-center">
            <v-flex>
              <h1 v-if="!hasResult" class="title">조회된 데이터가 없습니다</h1>
            </v-flex>
          </v-layout>
        </v-container>

          <v-layout
            column
            fill-height
          >
            <v-container v-if="!hasResult" fill-height fluid>
              <v-layout column class="text-xs-center">
                <v-flex  >
                  <h1 v-if="!hasResult" class="title">조회된 데이터가 없습니다</h1>
                </v-flex>
              </v-layout>
            </v-container>

            <v-flex>
              <template v-for="(item, index) in listReverse">
                <delivery-list-item v-bind:key="index"
                                    v-bind:title="item.status"
                                    v-bind:primary-chip="item.occurAirport"
                                    v-bind:green-chip="item.flightNo"
                                    v-bind:pink-chip="item.desc"
                                    v-bind:date="item.occurDate"></delivery-list-item>
                <v-divider v-if="index + 1 < model.list.length" :key="`divider-${index}`"></v-divider>
              </template>
            </v-flex>

          </v-layout>

        <!--<v-flex>-->
        <!--<template v-for="(item, index) in this.model.bookingList">-->
        <!--<delivery-list-item v-bind:key="index"-->
        <!--v-bind:title="item.flightNumber"-->
        <!--v-bind:primary-chip="item.flightNumber"-->
        <!--v-bind:green-chip="'신고번호:'+item.flightNumber"-->
        <!--&gt;</delivery-list-item>-->
        <!--<v-divider v-if="index + 1 < model.bookingList.length" :key="`divider-${index}`"></v-divider>-->
        <!--</template>-->
        <!--</v-flex>-->
      </v-card>
    </v-flex>
  </v-layout>

</template>

<script>
import LabelText from '../LabelText'
import DeliveryListItem from '../DeliveryListItem'

export default {
  name: 'KoreanAirCargoCard',
  components: {LabelText, DeliveryListItem},
  props: ['model'],
  data () {
    return {
      dialog2: false,
      showTooltip: false
    }
  },
  computed: {
    listReverse: function () {
      return [...this.model.list].reverse()
    },
    hasResult: function () {
      // return false
      return this.model.list.length > 0
    }
  },
  methods: {
    clickLabel: function (type) {
      this.showTooltip = !this.showTooltip
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/card/KoreanAirCargoCard.vue